module.exports = __webpack_public_path__ + "img/GrizzledPeaks-800-450.977a2fab.jpg";